"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setToHappen = void 0;
const setToHappen = (fn, date) => {
    return setTimeout(fn, date.getTime() - Date.now());
};
exports.setToHappen = setToHappen;
